// extracted by mini-css-extract-plugin
export default {"wrapper":"ClickableWrapper_wrapper__N7tz4","clickable":"ClickableWrapper_clickable__N8m6d","disabled":"ClickableWrapper_disabled__-WaEl"};